<template>
    <div>
        <section class="main-slider">
            <div class="page-header-bg" :style="{backgroundImage: weldInfo.bannerUrl}">
            </div>
            <div class="container">
                <div class="page-header__inner">
                    <h1>
                        {{ weldInfo.title }}
                    <!-- {{ $t(`resource.${weldInfo.i18n_title}`) }} -->
                    </h1>
                    <div class="page-header__inner_text">
                        {{ weldInfo.text }}
                        <!-- {{ $t(`resource.${weldInfo.i18n_text}`) }} -->
                    </div>
                 
                </div>
                <div class="page-header__breul">
                    <el-breadcrumb separator="/" >
                        <el-breadcrumb-item :to="{ path: 'home' }">
                            <!-- 首页 -->
                             {{ $t('resource.resource_breadcrumb_home') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item :to="{ path: 'resourceList' }">
                            <!-- 资料中心 -->
                             {{ $t('resource.resource_breadcrumb_resourceCenter') }}
                        </el-breadcrumb-item>
                        <el-breadcrumb-item >
                            <!-- 焊工小知识 -->
                            {{ $t('resource.resource_breadcrumb_weldKnowledge') }}
                        </el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </div>
        </section>
      

		<section class="blog-details">
            <div class="container">
                <div class="row" >
					
                    <div class="col-lg-12 col-xl-12">
                        <div class="details__centent">
                            <!-- 内容 -->
                            <div class="row_centent" >
                                <!-- <div class="inside-tex warp wow fadeInUp animated" style="visibility: visible; animation-name: fadeInUp;">                                   
                                        <div v-for="(item, index) in list" :key="index" >
                                            <p v-if="item.type=='text'" style="font-size: var(--font-size-16);white-space: normal;line-height: 32px" v-html="item.content"></p>
                                            <p style="text-align: center;" v-else> 
                                                <img class="details__centent_img"  :src=" item.content " >
                                            </p>
                                            
                                        </div>
                               
                                </div> -->
                                <p class="item_text"  >
                                    <!-- 很多人知道焊工证，但是并不一定完全不了解焊工证；
                                    比如焊工证证书是什么样的呢? 焊工证由什么部门颁发? 焊工证是怎么考的？ 接下来为大家来介绍下焊工证。
                                 -->
                                    {{ $t('resource.resource_weldKnowledge_content_1') }}
                                </p>
                                <p class="item_title" >
                                    <!-- 一、应急管理厅特种操作证 -->
                                    {{ $t('resource.resource_weldKnowledge_title_1') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 焊工证，也被称为焊工上岗证或熔化焊接与热切割作业证，是由应急管理部（原安监局）颁发的像身份证一样大小，是IC卡形式的。
                                    这是焊工从事相关作业时必须持有的证件，具有极强的法律效应。也就是说，如果焊工在某个单位任职，
                                    如果遇到相关部门进行安全检查，一旦查出没有焊工操作证却从事相关工作，不仅会被开除，还要追究单位的责任，尤其是当发生安全事故时，没有证书就会处于劣势。 -->
                                   {{ $t('resource.resource_weldKnowledge_content_2') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 焊工操作证不分等级，一般只要是从事金属焊接切割作业(电焊、气焊、弧焊、电焊气割)等工作，都是领取同一种焊工操作证，不需要细化，证书带磁卡，全国通用。 -->
                                    {{ $t('resource.resource_weldKnowledge_content_3') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- IC卡版证书样本 -->
                                      {{ $t('resource.resource_weldKnowledge_content_4') }}
                                </p>
                                <p style="text-align: center;" > 
                                    <img class="details__centent_img"  :src=" weldInfo.specialFront " >
                                </p>
                                <p style="text-align: center;" > 
                                    <img class="details__centent_img"  :src=" weldInfo.specialOpposite " >
                                </p>
                                <p  class="item_text" >
                                    <!-- 如何查询焊工证的真伪? 电工特种操作证是由应急管理厅颁发，所以在应急管理厅官网即可查明真伪。 -->
                                    {{ $t('resource.resource_weldKnowledge_content_5') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 证书查询：特种作业操作证查询 -->
                                    {{ $t('resource.resource_weldKnowledge_content_6') }}
                                    <a target="_blank"
									href="https://cx.mem.gov.cn/special?index=0">https://cx.mem.gov.cn/special?index=0</a>
                                </p>
                                <p style="text-align: center;" > 
                                    <img class="details__centent_img"  :src=" weldInfo.specialQuery " >
                                </p>

                                <p class="item_title" >
                                    <!-- 二、焊工职业资格证 -->
                                    {{ $t('resource.resource_weldKnowledge_title_2') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 焊工职业资格证书俗称“等级证”共分为五个级别，代表了焊工的不同技术技巧能力,是由当地人社部(全称人力资源与社会保障局(厅))颁发的国家级职业资格证书，
                                    要先经过统一组织培训考试，考试合格后才能进行职业资格鉴定并领取证书，
                                    焊工职业资格证不是上岗必须要的证件， 主要用于评定焊工的技术等级和工资等级标准。
                                    但在任职中对升职、加薪、职称评定有效，而且还可以申请国家补贴，焊工资格证是永久有效的，不需要复审。 -->
                                    {{ $t('resource.resource_weldKnowledge_content_7') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 焊工资格证样本 -->
                                      {{ $t('resource.resource_weldKnowledge_content_8') }}
                                </p>
                                <p style="text-align: center;" > 
                                    <img class="details__centent_img"  :src="weldInfo.qualification " >
                                </p>
                                <p  class="item_text" >
                                    <!-- 如何查询焊工证的真伪? 焊工职业资格证是由人力资源和社会保障部颁发的 -->
                                     {{ $t('resource.resource_weldKnowledge_content_9') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 证书查询: -->
                                     {{ $t('resource.resource_weldKnowledge_content_10') }}
                                    <a target="_blank"
									href="http://zscx.osta.org.cn/">http://zscx.osta.org.cn/</a>
                                </p>
                                <p style="text-align: center;" > 
                                    <img class="details__centent_img"  :src=" weldInfo.qualificationQuery " >
                                </p>

                                <p class="item_title" >
                                    <!-- 三、特种设备作业焊工证 -->
                                    {{ $t('resource.resource_weldKnowledge_title_3') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 特种设备作业焊工证，也被称为压力容器焊工证，主要针对压力容器的焊接人员。由质监局颁发，是从事压力容器焊接必备的一个从业证书。
                                    因为承压类和管道焊接对焊接技术的要求是比较高的，第一是要确保安全，第二就是要确保焊接的质量合格，这时候就需要我们持有焊工的特种设备作业证了。 -->
                                    {{ $t('resource.resource_weldKnowledge_content_11') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 特种设备作业焊工证样本 -->
                                     {{ $t('resource.resource_weldKnowledge_content_12') }}
                                </p>
                                <p style="text-align: center;" > 
                                    <img class="details__centent_img"  :src="weldInfo.taskWeld " >
                                </p>
                                <p  class="item_text" >
                                    <!-- 如何查询焊工证的真伪? 　特种设备焊接证，也称压力容器焊工证，由质监局颁发 -->
                                    {{ $t('resource.resource_weldKnowledge_content_13') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 查询网址： -->
                                    {{ $t('resource.resource_weldKnowledge_content_14') }}
                                    <a target="_blank"
									href="http://cnse.samr.gov.cn/Publicity/Equipment">http://cnse.samr.gov.cn/Publicity/Equipment</a>
                                </p>
                                <p style="text-align: center;" > 
                                    <img class="details__centent_img"  :src=" weldInfo.taskWeldQuery " >
                                </p>

                                <p class="item_title" >
                                    <!-- 四、建筑焊工证 -->
                                      {{ $t('resource.resource_weldKnowledge_title_4') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 建设厅的焊工证只使用于建筑行业使用、全称建筑施工特种作业操作资格证、证书每2年进行一次复审。因为现在焊工证还不是统一发放的，它的管辖部门是建设厅，发证单位是直辖市的为当地建交委，省级单位是当地城乡建设厅。
                                    而且焊工从事的行业也比较纷杂，建设厅颁发的证件主要是针对建筑行业。 -->
                                     {{ $t('resource.resource_weldKnowledge_content_15') }}
                                
                                </p>
                                <p  class="item_text" >
                                    <!-- 建筑焊工证样本 -->
                                    {{ $t('resource.resource_weldKnowledge_content_16') }}
                                </p>
                                <p style="text-align: center;" > 
                                    <img class="details__centent_img"  :src="weldInfo.building " >
                                </p>
                                <p  class="item_text" >
                                    <!-- 如何查询焊工证的真伪? 建筑焊工是由建设部门颁发，登录发证地建设厅官网进行查明真伪。 -->
                                     {{ $t('resource.resource_weldKnowledge_content_17') }}
                                </p>
                               
                                <p >
                                    <!-- 综上所述，应急管理厅特种操作证、焊工职业资格证、特种设备作业焊工证以及建筑焊工证在颁发机构、目的、适用范围和重要性等方面都存在差异。每种证书都有其特定的应用领域和价值，焊工可以根据自身的工作需求和发展方向选择合适的证书进行考取。 -->
                                     {{ $t('resource.resource_weldKnowledge_content_18') }}
                                </p>

                                <p class="item_title" >
                                    <!-- 焊工证报考条件及资料 -->
                                    {{ $t('resource.resource_weldKnowledge_title_5') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 1、年满18周岁-60周岁之间 -->
                                    {{ $t('resource.resource_weldKnowledge_content_19') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 2、具有相应的操作能力，身体无重大疾病 -->
                                     {{ $t('resource.resource_weldKnowledge_content_20') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 3、身份证复印件 -->
                                     {{ $t('resource.resource_weldKnowledge_content_21') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 4、本人蓝底寸照 -->
                                     {{ $t('resource.resource_weldKnowledge_content_22') }}
                                </p>
                                <p  class="item_text" >
                                    <!-- 5、本人初中及以上学历证明 -->
                                      {{ $t('resource.resource_weldKnowledge_content_23') }}
                                </p>
                            </div>
                          
                        </div>
                    </div>
                </div>
			</div> 
         
		</section>
    </div>
</template>

<script >
import { MixinsList } from '@/mixins/mixins' 
import { loadData } from '@/utils/dataLoader'
export default {
    name: 'weldCertificate',
     mixins: [MixinsList],
    components: { },
    data () {
        return {          
            weldInfo: {},  // 信息
            list: [],
            seekShow: false,
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () {
         // 确定选中的菜单
        $('.current').removeClass('current');  
        $('.resource_li').addClass('current');
    },
    methods: {
      
        // 获取内容
        async getList() {
            // const { result } = res
           	// this.weldInfo = result['weldKnowledge']

           try {
              const  result  = await loadData('down', this.lang)
            this.weldInfo = result['weldKnowledge']
            } catch (error) {
                console.log(error)
            }

        },
    }
}
</script>
<style scoped>
.blog-details {
    background: var(--notech-extra);
    padding: 60px 0 60px;
}
body {
	color: var(--notech-black) !important;
}
.page-header-bg {
    background-color: transparent; 
}

.page-header__inner h1{
    font-size: var(--font-size-45);
    /* width: 45%; */
    /* text-align: justify; */
    /* text-align-last: justify; */
    text-justify: distribute-all-lines;  /*兼容ie*/
 }

.page-header__inner_text{
    width: 50%;
    font-size: var(--font-size-20);
    margin-top: 13px;
    line-height: 1.75;
    color: var(--notech-white);
 }
 .page-header__inner_action {
    margin-top: 50px;
    display: flex;
 }
 .page-header__inner_action_item {
    cursor: pointer;
    text-align: center;
    color: var(--notech-white);
    border-radius: 5px;
    width: 200px;    
   
    border: 1px solid rgba(169, 183, 222, 0.86);
    padding: 10px 15px;
    background: rgba(255, 255, 255, 0.2);
    position: relative;
    transition: all 0.36s;
    
 }

 /* 面包屑 */
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
    color: var(--notech-white) ;
}
::v-deep .el-breadcrumb__inner {
    /* color: var(--notech-primary) !important; */
    color: var(--notech-white);
    font-size: var(--font-size-16);
    font-weight: 700;
    transition: all 500ms ease;
}
/* 内容 */
.details__centent {
    margin-top: 10px;
    background: #fff;
    padding: 45px 100px;
    box-shadow: 2.5px 4.33px 50px 0px rgba(30, 39, 61, 0.04);
}
/* 标题过长隐藏 */
.content__p_text {
    width: 300px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .icon {
    cursor: pointer;
  }
  .details__centent_img{
    max-width: 100%;
  }
  .row_centent {
    font-size: var(--font-size-16);
    white-space: normal;
    line-height: 32px; 
  }
  .item_title {
    font-weight: bold; 
    margin: 20px 0;
  }
  .item_text {
    text-indent: 32px;
    margin: 10px 0;
  }
</style> 
